//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// У v-autocomplete есть атрибут return-object, для возврата item целиком
// no-filter позволяет оставить server side фильтрацию

export default {
    props: {
        value: [Number, String, Boolean],
        // forceValue: {
        //     type: [Number, String, Boolean], // подстановка значения
        //     default: false
        // },
        itemText: String,
        items: Array,
        label: String,
        // autoFill: Boolean,
        comment: String,
        // append: String,
        // mask: String,
        type: String,
        rules: Array,
        search: [Object, Function],
        fieldLabel: String,
        placeholder: String,
        outlined: Boolean,
        // {
        //     type: Boolean,
        //     default: false
        // },
        disabled: Boolean,

        // replaceEngToRu: {
        //     type: Boolean,
        //     default: true
        // },

        // Ограничения ввода:
        isMoney: Boolean,
        isCyrilic: Boolean,
        isCyrilicIssued: Boolean,
        isCyrilicPlace: Boolean,
        isEngEmail: Boolean,
    },
    computed: {
        fieldValue: {
            get() {
                return this.value
            },
            set( val ) {
                val = this.applyInputRestrictions(val);
                this.$emit('input', val);
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(
                    () => {
                        this.search(this.fieldValue);
                    },
                    this.searchDelay
                );
            }
        },
        fieldItems() {
            let value = this.items.filter((item, i) => !(item.value === this.fieldValue && i > 0));

            return this.items[0]?.value ? value : [];
        },
        // translatedFieldLabel() {
        //     return this.$t(this.fieldLabel) || this.fieldLabel;
        // },
        fieldAttrs() {
            return {
                autocomplete: false,
                placeholder: this.placeholder,
                type: this.type,
                label: this.fieldLabel,
                readonly: this.menu,
                rules: this.rules,
                disabled: this.disabled,
                'hide-details': false,
                // height: "47px",
                // 'background-color': "white",
                'validate-on-blur': true,
            }
        },
        isListActive() {
            return (this.isFocus && this.fieldItems.length > 0) 
                    || this.isMouseOver;
        }
    },
    data: () => ({
        isFocus: false,
        isMouseOver: false,
        // fieldValue: "",
        listKey: 0,
        searchTimeout: null,
        searchDelay: 500,
    }),
    mounted() {
        // if (this.forceValue) {
        //     this.fieldValue = this.forceValue;
        //     this.search(this.forceValue);
        // }

        // this.forceValue && (this.fieldValue = this.forceValue);
    },
    watch: {
        // forceValue(val) {
        //     this.$nextTick(
        //         () => this.fieldValue = val
        //     );
        //     // this.search(val);
        // },
        fieldItems( val ) {
            this.listKey=0;
        }
    },
    methods: {
        changeItem(val) {
            this.fieldValue = val;
            this.isFocus = false;
            this.isMouseOver = false;
        },
        changeItemByKey( e ) {
            const length = this.fieldItems.length - 1;
            
            e.key == "ArrowDown" && (this.listKey < length && this.listKey++);
            e.key == "ArrowUp" && (this.listKey > 0 && this.listKey--);

            this.isFocus = true;
            e.key =="Enter" && (
                this.fieldValue = this.fieldItems[this.listKey].value, 
                this.isFocus = false
            );
            e.key =="Escape" && (this.isFocus = false);
        },
        applyInputRestrictions(val) {
            let oldval = val;
            let key;

            if (this.isMoney) {
                val = val.replace(/\D/g, "");
            }
            if (this.isEngEmail) {
                val = val.replace(/[^a-zA-Z\-0-9.@]/g, "");
            }
            if (this.isCyrilic) {
                val = val.replace(/[^а-яА-ЯёЁ -]/g, "");
            }
            if (this.isCyrilicIssued) {
                val = val.replace(/[^0-9А-яЁё/\\(№\-.,")\s]/g, "");
            }
            if (this.isCyrilicPlace) {
                val = val.replace(/[^0-9А-яЁё("\-.)\s]/g, "");
            }
            if (this.replaceEngToRu) {
                key = oldval.replace(val, "");
                if (key.length == 1) {
                    val += replaceToCyrilic(key);
                }
            }
            return val;
        },
    },
};
